import { throttle } from 'lodash';
import { useEffect } from 'react';

const useWindowSizeChanged = (callback: () => void) => {
    useEffect(() => {
        const throttledCallback = throttle(callback, 100);

        window.addEventListener('resize', throttledCallback);

        callback();

        return () => window.removeEventListener('resize', throttledCallback);
    }, []);
};

export default useWindowSizeChanged;
